import { render, staticRenderFns } from "./r-item-boost-config.vue?vue&type=template&id=433e28fe"
import script from "./r-item-boost-config.vue?vue&type=script&lang=js"
export * from "./r-item-boost-config.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('433e28fe')) {
      api.createRecord('433e28fe', component.options)
    } else {
      api.reload('433e28fe', component.options)
    }
    module.hot.accept("./r-item-boost-config.vue?vue&type=template&id=433e28fe", function () {
      api.rerender('433e28fe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/item/boost/r-item-boost-config.vue"
export default component.exports